/** 퀴즈 문제 이미지·과제 제출 이미지에 대한 유저당 Storage 상한 */
export const USER_STORAGE_QUOTA_BYTES = 100 * 1024 * 1024;

export const USER_STORAGE_QUOTA_LABEL = '100MB';

/** 햄버거 메뉴 게이지 설명용 */
export const USER_STORAGE_QUOTA_SCOPE_LABEL = '퀴즈·과제 제출';
